import { loyaltySelectors } from './models/loyalty';

export const selectors = {
  loyalty: loyaltySelectors,
};
